import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Store } from '@/store/Store'
import { titleTagSuffix } from '@/common/constants'
import { Helmet } from '@/common/components/Helmet'
import HgCircularProgressGlobal from '@/common/components/ui/atoms/HgCircularProgressGlobal'

export const Route = createFileRoute('/app/resources')({
  component: RouteComponent,
})

function RouteComponent() {
  const [ready, setReady] = useState<boolean>(false)

  // from redux
  const appMeta = useSelector((state: Store) => state.app_meta)
  const currentUser = useSelector((state: Store) => state.auth.currentUser)
  const programs = useSelector((state: Store) => state.programs)

  // Set "ready" once deps are loaded
  useEffect(() => {
    let newReady =
      currentUser && currentUser.bootstrapped && appMeta.loaded && programs.loaded
    setReady(newReady)
  }, [currentUser, appMeta.loaded, currentUser?.bootstrapped, programs.loaded])

  // Waiting for basic info / redux
  if (!ready) {
    return <HgCircularProgressGlobal />
  }

  return (
    <>
      <Helmet>
        <title>Resources & Trainings{titleTagSuffix}</title>
        <meta property="og:title" content="Resources & Trainings" />
        <meta
          property="og:url"
          content={`${import.meta.env.VITE_SITE_ROOT}/resources`}
        />
      </Helmet>

      <Outlet />
    </>
  )
}
